import axios from "axios";
/**
 *
 * NASA API
 *
 * https://api.nasa.gov
 * https://github.com/nasa/apod-api
 * https://github.com/chrisccerami/mars-photo-api
 *
 */
const API_KEY = 'rt4vY3GxQ5sphrVit5elLXDPjPNtjz38cPVf0JMS';
const BASE_URL = 'https://api.nasa.gov/mars-photos/api/v1';
const marsRest = axios.create({
    baseURL: BASE_URL,
    params: { api_key: API_KEY }
    //    baseURL: 'https://mars-photos.herokuapp.com/',
});
const imagesRest = axios.create({
    baseURL: 'https://images-api.nasa.gov',
});
const apodRest = axios.create({
    baseURL: 'https://api.nasa.gov/planetary/apod',
    params: { api_key: API_KEY }
});
export var Nasa;
(function (Nasa) {
    let Rovers;
    (function (Rovers) {
        Rovers["Curiosity"] = "curiosity";
        Rovers["Opportunity"] = "opportunity";
        Rovers["Spirit"] = "spirit";
        Rovers["Perseverance"] = "perseverance";
    })(Rovers = Nasa.Rovers || (Nasa.Rovers = {}));
    Nasa.api = {
        mars: {
            getRoverPhotos: (rover, sol, page, camera) => {
                return marsRest.get(`/rovers/${rover}/photos?`, { params: { sol, page, camera } }).then(response => response.data);
            },
            getMission: (rover) => {
                return marsRest.get(`/manifests/${rover}`).then(response => response.data);
            }
        },
        images: {
            search: (query, page) => {
                return imagesRest.get('/search', { params: { q: query, page } }).then(response => response.data);
            }
        },
        apod: {
            get: (request) => {
                return apodRest.get('', { params: request }).then(response => response.data);
            }
        }
    };
    let Apod;
    (function (Apod) {
        let MediaType;
        (function (MediaType) {
            MediaType["Image"] = "image";
            MediaType["Video"] = "video";
        })(MediaType = Apod.MediaType || (Apod.MediaType = {}));
    })(Apod = Nasa.Apod || (Nasa.Apod = {}));
})(Nasa || (Nasa = {}));
